import type EditorImage from '@src/slide/application/service/copy-paste/core/cp-image.new/image-edit-manager/core/editor-image';
import type { ImageCompressOptions } from '@src/slide/infrastructure/module/dependent/image/image-toolkit/image-compressor';
import type { ImageResource } from '@src/slide/infrastructure/module/dependent/image/image-toolkit/image-resource';

export interface IImageEditManager {
    /**
     * 正在进行替换图片操作
     */
    imageReplacing: boolean;
    // 替换图片动作，2代表是替换背景图片 1是替换前景图
    imageReplaceAction: number;
    // 等待剪切板数据
    clipDataWaiting: boolean;
    enableImageRecovery: boolean;

    createEditorImages(blobs: Blob[]): Promise<EditorImage[]>;

    bulkInsertBlobImages(blobs: Blob[]): Promise<void>;

    bulkReplaceBlobImages(
        blobs: Blob[],
        distModel: any,
    )

    /**
     * 图片上传（不走图片秒看，直接上传并返回http的图片地址）
     * @param blobs
     */
    uploadWithoutQuickLook(
        blobs: Blob[], tip?: string, compressOptions?: ImageCompressOptions): Promise<{ src: string }[]>;

    uploadAndUpdateImages(resources: ImageResource[]): void;
    /**
     * 从文件替换图片
     */
    replaceImageFromFile(imageReplaceAction: ImageReplaceAction)
    /**
     * 从剪贴板替换图片
     */
    replaceImageFromClipBoard(imageReplaceAction: ImageReplaceAction)

}

// FIXME: enum 不是 interface，放在 .interface 文件下不合理，会导致其他业务 import type interface 有冗余
export enum ImageReplaceAction {
    foreground = 1, // 前景图，及图片
    background = 2,  // 背景，即图片填充
    text = 3, // 文字填充
    multi = 4, // 多选的场景
}
